import { useQuery } from '@tanstack/react-query';
import { GLOBAL_NOTIFICATION_FETCH_INTERVAL_S } from 'app/config/constants';
import { fetchActiveGlobalNotification } from "app/shared/global-notification/global-notification.service";

export const fetchActiveGlobalNotificationQuery = ({ enabled }) => {
  return useQuery({
    queryKey: ['global-notification-active'],
    queryFn: fetchActiveGlobalNotification,
    refetchInterval: GLOBAL_NOTIFICATION_FETCH_INTERVAL_S * 1000,
    enabled: enabled ?? true,
  });
};
